const ProductAssetsFullScreenZoomControls = () => (
  <div className='product-assets-fullscreen-zoom-controls'>
    <input
      type='range'
      min='100'
      max='300'
      defaultValue='100'
      step='1'
      className='product-assets-fullscreen-zoom-controls-slider'
    />
  </div>
)

export default ProductAssetsFullScreenZoomControls
